/* jshint multistr: true */
/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import MediaEditorButton from 'app/components/PostingTool/MediaEditorButton.jsx';
import MediaUploader from 'app/components/PostingTool/MediaUploader.js';
import EmblaCarousel from 'app/components/common/EmblaCarousel.jsx';
import ErrorThumbnail from 'app/components/PostingTool/Accessories/ErrorThumbnail.jsx';
import Utilities from 'app/utility/Utilities.js';

class PostToolUploader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploaded: false,
            isUploading: false,
            thumbs: [],
            errors: [],
            progress: 0,
            service: 0,
            apiError: ''
        };

        this.uploadFile = this.uploadFile.bind(this);
        this.videoRef = React.createRef();
        this.releaseThumbs = this.releaseThumbs.bind(this);

    }

    static getDerivedStateFromProps(props, state) {

        let savedData = props.getPersistedData('mediaUploaderState');

        if (savedData && props.isModal) {
            props.clearPersistedData('mediaUploaderState');
            return savedData;
        } else {
            if (props.accessoryServiceId !== undefined && props.accessoryServiceId) {
                return {
                    service: props.accessoryServiceId
                };
            } else if (props.serviceType !== undefined && props.serviceType) {
                return {
                    service: props.serviceType
                };
            }
        }

        return null;

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.postData.cover_ms !== undefined && prevProps.postData.cover_ms !== this.props.postData.cover_ms) {
            if (this.videoRef.current) {
                this.videoRef.current.currentTime = this.props.postData.cover_ms / 1000;
            }
        }
    }

    releaseThumbs() {

        // clean up generated thumbs
        this.state.thumbs.map((thumb) => {
            URL.revokeObjectURL(thumb.thumb);
        });

    }

    uploadFile(acceptedFiles, rejections) {
        let formData = new FormData(),
            nextThumbs = [...this.state.thumbs];

        if (rejections.length) {
            let errorMsgs = [],
                errs = [];

            rejections.map(({ file, errors }) => {
                errors.map((e) => {
                    let errorThumb = null;
                    if (file.type.match(/image|video/)) {
                        if (!nextThumbs.find(({name}) => { return name === file.name})) {
                            nextThumbs.push({
                                name: file.name,
                                type: file.type,
                                thumb: URL.createObjectURL(file)
                            });
                        }
                    }
                    errs.push({
                        file: file.name,
                        error: e.message
                    });
                });

            });

            if (this.state.service) {
                let mediaError = {};
                mediaError[this.state.service] = errorMsgs;
                this.props.updateMediaErrors(mediaError);
            } else {
                this.setState({
                    errors: errs
                });
            }
        } else {
            if (this.state.service) {
                this.props.clearMediaErrors([this.state.service]);
            }
            this.setState({
                errors: []
            });
        }

        if (acceptedFiles.length) {

            formData.append('type', 'postMedia');

            acceptedFiles.map((file) => {
                formData.append('media[]', file);

                nextThumbs.push({
                    thumb: URL.createObjectURL(file),
                    type: file.type,
                    name: file.name,
                    hash: ''
                });

            });

            this.setState({
                isUploading: true,
                thumbs: nextThumbs
            });

            MediaUploader({
                formData,
                onUploadProgress: (e) => {
                    if (e.loaded > 0) {
                        this.setState({
                            progress: (e.loaded / e.total * 100)
                        });
                    }
                },
                responseCallback: (response) => {
                    let data = response.data,
                        nextThumbs = [...this.state.thumbs],
                        nextErrors = [...this.state.errors],
                        hasErrors = false;

                    if (data.media !== undefined && data.media.length) {
                        for (let i = 0; i < data.media.length; ++i) {
                            let thumbData = nextThumbs.find((thumb) => { return data.media[i].name === thumb.name; });
                            if (thumbData) {
                                thumbData.hash = data.media[i].hash;
                            }
                        }
                    }

                    if (this.state.service) {
                        this.props.attachMedia(data, this.state.service);
                    } else {
                        this.props.attachMedia(data);
                    }

                    if (data.errors !== undefined && data.errors.validation !== undefined && data.errors.validation.media !== undefined) {
                        Object.keys(data.errors.validation.media).map((file) => {
                            nextErrors.push({
                                file,
                                error: data.errors.validation.media[file]
                            });
                        });
                        hasErrors = true;
                    }

                    // advance to the editor if there are no errors, or i
                    if (!hasErrors) {
                        this.releaseThumbs();
                        this.props.showMediaEditor('imageEditor', this.state.service, nextThumbs[0].hash, true);
                    }

                    if (!this.props.isModal && hasErrors) {
                        let nextState = Utilities.deepClone(this.state);
                        nextState.isUploading = false;
                        nextState.thumbs = nextThumbs;
                        nextState.errors = nextErrors;
                        this.props.persistData('mediaUploaderState', nextState);
                        this.props.showMediaEditor('mediaUploader', this.state.service, '', true);
                    } else {
                        this.setState({
                            isUploading: false,
                            thumbs: nextThumbs,
                            errors: nextErrors
                        });
                    }

                },
                errorCallback: (error) => {
                    if (error.response) {
                        let errorData = error.response.data.errors || null,
                            errorMsgs = [];

                        const extractErrors = (obj) => {
                            if (obj && Object.keys(obj).length) {
                                Object.keys(obj).map((key) => {
                                    if (typeof obj[key] === 'string') {
                                        errorMsgs.push(obj[key]);
                                    } else if (Object.keys(obj[key])) {
                                        extractErrors(obj[key]);
                                    }
                                });
                            }
                        };

                        // session died before upload
                        if (error.response.status === 403) {
                            window.location.reload();
                            return;
                        }

                        if (error.response.status === 413) {
                            let mediaError = {};
                            if (this.state.service) {
                                this.setState({
                                    errors: 'File too large to upload'
                                });
                            } else {
                                mediaError[this.state.service] = "File too large to upload";
                            }
                            this.props.updateMediaErrors(mediaError);
                            this.setState({
                                isUploading: false,
                                progress: 0
                            });
                            return;
                        }

                        extractErrors(errorData);

                        if (errorMsgs.length) {
                            if (this.state.service) {
                                let mediaError = {};
                                mediaError[this.state.service] = errorMsgs.join(" ");
                                this.props.updateMediaErrors(mediaError);
                            } else {
                                this.setState({
                                    apiError: errorMsgs.join(" ")
                                });
                            }
                        } else if (error.response.data.error) {
                            this.setState({
                                apiError: `We couldn't complete your last request: ${error.response.data.error.msg}`
                            });
                        }

                    } else if (error.message) {
                        if (this.state.service !== undefined) {
                            let mediaError = {};
                            mediaError[this.state.service] = error.message;
                            this.props.updateMediaErrors(mediaError);
                        } else {
                            this.setState({
                                apiError: error.message
                            });
                        }
                    }

                    this.setState({
                        isUploading: false,
                        progress: 0
                    });
                }
            });

        }
    }

    render() {
        let instructions = null,
            maxFileSize = 0,
            uploaderError = null,
            constants = this.props.app.config.constants;

        const setMaxFileSize = (validator) => {
            if (validator && validator.fields !== undefined) {
                if (validator.fields.mb_id !== undefined) {
                    if (validator.fields.mb_id.allowed_types.image !== undefined && validator.fields.mb_id.allowed_types.image.max_bytes !== undefined) {
                        maxFileSize = Math.max(maxFileSize, validator.fields.mb_id.allowed_types.image.max_bytes);
                    }
                    if (validator.fields.mb_id.allowed_types.video !== undefined && validator.fields.mb_id.allowed_types.video.max_bytes !== undefined) {
                        maxFileSize = Math.max(maxFileSize, validator.fields.mb_id.allowed_types.video.max_bytes);
                    }
                }
            }
        };

        instructions = (
            <div className="instructions-wrapper">
                <div className="instructions">
                    <div>
                        <i className="upload-icon icon ion-image"></i>
                    </div>
                    {uploaderError}
                    <div>
                        Drag files to upload
                    </div>
                    <div>
                        or
                    </div>
                </div>
                <div className="faux-button" role="button" aria-label="Browse files">
                    browse
                </div>
            </div>
        );

        if (this.props.context !== 'shared') {
            instructions = (
                <div className="instructions-wrapper">
                    <div className="instructions">
                        <div>
                            <i className="upload-icon icon ion-image"></i>
                        </div>
                        <div>
                            add media
                        </div>
                    </div>
                </div>
            );
        }

        // figure out the biggest size a file can be and allow that... the media validators
        // on the backend will provide more info if things are too big, etc
        if (Object.keys(this.props.posts.postValidators).length) {
            let validator = null;

            // TODO: skip bluesky and maybe instagram
            if (this.state.service) {
                validator = this.props.posts.postValidators[this.state.service];
                // just use large default for bluesky because magic happens on the backend
                // to shrink photos
                if (parseInt(this.state.service) !== constants.POST_SVC_BLUESKY) {
                    setMaxFileSize(validator);
                }
            } else if (this.props.selectedServices !== undefined) {
                this.props.selectedServices.map((key) => {
                    validator = this.props.posts.postValidators[key];
                    if (parseInt(key) !== constants.POST_SVC_BLUESKY) {
                        setMaxFileSize(validator);
                    }
                });
            }
        }
        // if, for some reason the validators don't have max size or it isn't set
        // just default to allow the big files
        if (!maxFileSize) {
            maxFileSize = 8000000000;
        }

        let dropzoneContent = null;
        if (this.state.isUploading) {
            // never show 100% progress per charles and emily
            let progress = (this.state.progress < 99) ? this.state.progress : 99;
            dropzoneContent = (
                <div className="file-list progress-view">
                    <div className="thumb-wrapper">
                        <div className="image-wrapper">
                            <div className="working">
                                <i className="fa fa-circle-o-notch fa-spin"></i>
                                <div className="progress">
                                    {Math.floor(progress)}%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else if (!this.state.isUploading && this.state.thumbs.length && !this.props.isModal) {
            dropzoneContent = (
                <div className="file-list">
                        <EmblaCarousel options={{
                            container: ".carousel-slide-wrapper",
                            slide: ".carousel-slide",
                            align: 'center',
                            loop: true
                        }}
                        extraClasses={this.props.context}>
                        {this.state.thumbs.map((thumbData, i) => {
                            return (
                                <div key={`thumb-${i}`} className="carousel-slide thumb-wrapper">
                                    <div className="slide-wrapper">
                                        <div className="remove-file" role="button" aria-label="Remove Image" onClick={() => {
                                            this.props.removeThumb(thumbData.hash, this.state.service);
                                            if (this.state.service) {
                                                this.props.clearMediaErrors([this.state.service]);
                                            }
                                        }}>
                                            <i className="fa fa-times-circle"></i>
                                        </div>
                                        {this.props.supportsMediaEditing(thumbData.type) ? (
                                            <MediaEditorButton
                                                {...this.props}
                                                fileType={thumbData.type}
                                                hash={thumbData.hash}/>
                                        ) : null}
                                        <div className="image-wrapper">
                                            {thumbData.type.match(/video/) ? (
                                                <video ref={this.videoRef} width="175" height="auto" type={thumbData.type} controls>
                                                    <source src={thumbData.thumb + "#t=0.1"}/>
                                                    <div className="working">
                                                        <i className="fa fa-circle-o-notch fa-spin"></i>
                                                        <div className="progress">
                                                            Loading Thumb
                                                        </div>
                                                    </div>
                                                </video>
                                            ) : null}
                                            {thumbData.type.match(/image/) ? (
                                                <img className="file-thumb" src={thumbData.thumb}/>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </EmblaCarousel>
                </div>
            );
        }

        let modalActions = null,
            leftButton = null,
            rightButton = (
                <button type="button" className="btn-delete action-delete" onClick={() => {
                    let hash = this.state.thumbs.length ? this.state.thumbs[0].hash : '';
                    this.releaseThumbs();
                    this.props.showMediaEditor('imageEditor', this.state.service, hash, true);
                }}>
                    Next
                </button>
            );

        if (this.props.isModal) {
            // never show the carousel in modal mode
            if (dropzoneContent && !this.state.isUploading) {
                dropzoneContent = null;
            }

            if (!this.state.thumbs.length || this.state.isUploading) {
                rightButton = (
                    <button type="button" className="btn-delete action-delete disabled" disabled="disabled">
                        Next
                    </button>
                );
            }

            if (this.state.errors.length) {
                leftButton = (
                    <div role="button" className="action-cancel" onClick={() => {
                        this.releaseThumbs();
                        this.setState({
                            errors: []
                        });
                    }}>
                        Retry
                    </div>
                );
                if (!this.state.thumbs.length) {
                    rightButton = (
                        <button type="button" className="btn-delete action-delete" onClick={() => {
                            this.releaseThumbs();
                            this.setState({
                                errors: []
                            });
                        }}>
                            Upload Media
                        </button>
                    )
                }
                dropzoneContent = (
                    <div className="media-upload-errors">
                        <h3>We weren't able to upload these files:</h3>
                        <div className="file-list error">
                            {this.state.errors.map((error, i) => {
                                let errorThumb = this.state.thumbs.find(({name}) => { return error.file === name; });

                                return (
                                    <ErrorThumbnail
                                        error={[error.error]}
                                        errorThumb={errorThumb}
                                        key={`${error.file}-${i}`}/>
                                );
                            })}
                        </div>
                    </div>
                );
            } else {
                leftButton = (
                    <div role="button" className="action-cancel" onClick={() => {
                        this.releaseThumbs();
                        this.props.cancelAction();
                    }}>
                        Go back
                    </div>
                );
            }
            modalActions = (
                <div className="pt-accessory-actions">
                    {leftButton}
                    {rightButton}
                </div>
            )
        }

        let apiError = null;
        if (this.state.apiError) {
            apiError = (
                <div className="upload-error">{this.state.apiError}</div>
            );
        }

        return (
            <div className={`pt-media-block image-drop ${this.props.context} ${this.props.modalActions ? 'upload-modal' : ''} ${(this.props.hasError) ? 'error' : ''}`}>
                {apiError}
                <div className="media-drop">
                    <Dropzone
                        accept={'image/*, video/*'}
                        maxFiles={0}
                        maxSize={maxFileSize}
                        onDrop={this.uploadFile}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()}/>
                                {(dropzoneContent) ? dropzoneContent : instructions}
                            </div>
                        )}
                    </Dropzone>
                </div>
                {modalActions}
            </div>
        );
    }

};

PostToolUploader.propTypes = {
    context: PropTypes.string,
    selectedSocials: PropTypes.object,
    isModal: PropTypes.bool
};

PostToolUploader.defaultProps = {
    context: 'shared',
    selectedSocials: {},
    isModal: false
};

export default PostToolUploader;
